import axios from 'axios';

const state = () => ({
  functions: [],
});

const getters = {};

const mutations = {
  SET_FUNCTIONS(state, functions) {
    state.functions = functions;
  },
};

const actions = {
  //Function
  getFunctions({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/Function')
        .then((response) => {
          let enabledFunctions = response.data.filter(
            (item) => item.isEnabled && item.displayInMobileApp,
          );
          commit('SET_FUNCTIONS', enabledFunctions);
          resolve(enabledFunctions);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
